var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledClipped312X309 = function SvgFilledClipped312X309(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 350 415"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312.118,
    height: 309.394,
    x: 148.248,
    y: -12.442,
    rx: 31.746,
    transform: "rotate(46.625 148.248 -12.442)"
  })));
};
export default SvgFilledClipped312X309;